import React, { useCallback } from 'react';
import { ICellRendererParams } from 'ag-grid-community';

type SelectOption = {
  label: string;
  value: string;
};

interface TaxSummarySelectCellRendererProps extends Partial<ICellRendererParams> {
  options: SelectOption[];
  isInEditMode?: boolean;
  isCellEditable?: boolean;
  onValueChange?: (newValue: number | null) => void;
}

const TaxSummarySelectCellRenderer = ({
  value,
  options,
  isInEditMode,
  isCellEditable,
  onValueChange,
}: TaxSummarySelectCellRendererProps) => {
  const label = options.find(option => String(option.value) === String(value))?.label ?? '';

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLSelectElement>) => {
      const numericValue = Number(event.target.value);
      onValueChange?.(Number.isNaN(numericValue) ? null : numericValue);
    },
    [onValueChange],
  );

  if (!isInEditMode || !isCellEditable) {
    return <span>{label}</span>;
  }

  const selectedValue = options.some(option => String(option.value) === String(value))
    ? String(value)
    : '';

  return (
    <span onClick={event => event.stopPropagation()}>
      <select
        className="slt-tax-summary-native-select"
        style={{ width: '100%', height: '100%', minHeight: 28, boxSizing: 'border-box' }}
        value={selectedValue}
        onMouseDown={event => event.stopPropagation()}
        onClick={event => event.stopPropagation()}
        onChange={handleChange}
      >
        <option value="" disabled>
          Select option
        </option>
        {options.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </span>
  );
};

export default TaxSummarySelectCellRenderer;
